/**
 * "Does this pricelist actually show anything" predicates for the services step.
 *
 * A pricelist only renders when it has at least one priced service variant or a
 * real visit price, so the offer-review modal uses the very same test to decide
 * whether the Services step exists at all (COMY1-333) — otherwise a supplier
 * whose offered pricelists are all still unpriced gets an empty step.
 */

export const hasPricedVariants = (service) =>
  Array.isArray(service?.variants) &&
  service.variants.some(
    (variant) => variant.price !== null && variant.price !== 0
  );

export const hasValidVisitPrice = (pricelist) =>
  pricelist &&
  pricelist.visit_price !== null &&
  pricelist.visit_price !== undefined &&
  pricelist.visit_price_relevant;

export const subPricelistHasPricedServices = (sub) =>
  Array.isArray(sub?.services) &&
  sub.services.some((service) => hasPricedVariants(service));

/** True when the pricelist has content the services step can render. */
export const isRenderablePricelist = (pricelist) =>
  (Array.isArray(pricelist?.sub_pricelists) &&
    pricelist.sub_pricelists.some(subPricelistHasPricedServices)) ||
  hasValidVisitPrice(pricelist);
